import { ComponentStylesWithFns } from '../../../theme/styles.helpers';

export const FormInputStyles: ComponentStylesWithFns = {
  root: {},
};
